import React, { useEffect, useState, ReactElement } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutline';
import { IconButton, Snackbar, SnackbarProps } from '@material-ui/core';
import { useStyles } from './AlertSnackbar.styles';
import CloseIcon from '@material-ui/icons/Close';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { AlertType, ErrorAlertTypes, SuccessAlertTypes } from '../../const/alerts';

interface AlertSnackbarProps extends SnackbarProps {
  text: string | ReactElement;
  alertType: AlertType;
  open: boolean;
  forceClosing?: boolean;
  onForceClosed?: () => void;
}
export const AlertSnackbar: React.FC<AlertSnackbarProps> = ({ alertType, forceClosing, onForceClosed, ...props }) => {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    props.open
      ? setOpen(props.open)
      : setTimeout(() => {
          setOpen(false);
        }, 4000);
  }, [props.open]);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (forceClosing) {
      setOpen(false);
      onForceClosed && onForceClosed();
    }
  }, [forceClosing]);

  return (
    <>
      {SuccessAlertTypes.includes(alertType) && (
        <Snackbar
          {...props}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
          message={props.text}
        >
          <span className={classes.success}>
            <CheckCircleIcon className={classes.iconSuccess} />
            {props.text}
            <IconButton disableRipple size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon className={classes.iconClose} fontSize="small" />
            </IconButton>
          </span>
        </Snackbar>
      )}
      {ErrorAlertTypes.includes(alertType) && (
        <Snackbar
          {...props}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={open}
          autoHideDuration={3000}
          onClose={handleClose}
          message={props.text}
        >
          <span className={classes.error}>
            <ErrorOutlineIcon className={classes.iconError} />
            {props.text}
            <IconButton disableRipple size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon className={classes.iconClose} fontSize="small" />
            </IconButton>
          </span>
        </Snackbar>
      )}
    </>
  );
};
